export default __webpack_public_path__ + "static/d08-bf3e8cfe25cb505b038453cd4440704e.png";